import './Settings.scss'
import { useState, useEffect } from 'react';
import { Box, FormControlLabel, IconButton, Modal, Switch, Typography } from '@mui/material'
import SettingsIcon from '@mui/icons-material/Settings';
import CloseIcon from '@mui/icons-material/Close';
import { UserSettings } from '../../constants/user_constants';
import { setLocalStorageItem } from '../localStorageWatcher';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { IMapFeatureConfigs } from '../../models/app_models';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 400,
  width: "85%",
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  padding: "5px"
};

const settingsOptions = [
    {
        title: "Theme",
        options: [
            {label: "Darkmode", value: true, name: UserSettings.DARKMODE}
        ]
    },
    {
        title: "Map",
        options: [
            {label: "Show All Points", value: false, name: UserSettings.MAP_OVERLAP},
            {label: "Show Marker Text", value: true, name: UserSettings.MARKER_TEXT},
            {label: "Show Side List", value: true, name: UserSettings.SHOW_MAP_LIST, featureConfig: 'list_view'}
        ]
    }
]

interface ISettingsProps {
    showSettings: boolean
    showSettingsClicked: () => void
}

export const Settings = (props: ISettingsProps) => {
    const [currentSettings, setCurrentSetings] = useState(settingsOptions)
    const appSlice = useSelector((state: RootState) => state.app) 

    useEffect(() => {
        settingsOptions.forEach((setting) => {
            setting.options.forEach((option) => {
                let existingValue = localStorage.getItem(option.name)
                if(existingValue)
                    option.value = existingValue.toLowerCase() === "true"
            })
        })
    }, [])

    const handleSettingsClick = () => {
        props.showSettingsClicked()
    }

    const handleSettingClicked = (settingIndex: number, optionIndex: number) => {
        const newSettings = currentSettings.map((setting, sIdx) => {
            if (sIdx !== settingIndex) return setting
            else {
                const updatedOptions = setting.options.map((option, oIdx) => {
                    if(oIdx === optionIndex) {
                        option.value = !option.value
                        setLocalStorageItem(option.name, option.value.toString())
                    }
                    return option
                })
                return {...setting, options: updatedOptions}
            }
        })
        setCurrentSetings(newSettings)
    }

    const checkFeatureConfig = (settingTitle: string, feature: string) => {
        let featureAllowed = false
        if (settingTitle.toLowerCase().trim() === 'map'){
            if (appSlice.appFeatureConfigs){
                const mapFeatureConfigs = appSlice.appFeatureConfigs.map
                const featureKey = feature as keyof IMapFeatureConfigs
                featureAllowed = mapFeatureConfigs[featureKey]
            }
        }
        return featureAllowed
    }

    return (
        <>
            <IconButton
                size="large"
                aria-controls="settings"
                aria-haspopup="true"
                color="inherit"
                onClick={handleSettingsClick}
            >
                <SettingsIcon sx={{color: "text.primary"}}/>
            </IconButton>
            <Modal
                open={props.showSettings}
                onClose={handleSettingsClick}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle}>
                    <Box sx={{display: "flex", flexDirection: "column"}}>
                        <div className='settings-modal-close-icon-wrapper'>
                            <IconButton
                                sx={{color: "text.secondary", padding: 0}}
                                size="small"
                                aria-controls="close"
                                aria-haspopup="true"
                                color="inherit"
                                onClick={handleSettingsClick}
                            >
                                <CloseIcon />
                            </IconButton>
                        </div>
                        {/* Body */}
                        <Box sx={{padding: "10px", paddingTop: 0}}>
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                Settings
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                {currentSettings.map((setting, settingIndex) => 
                                    <Box key={settingIndex} sx={{marginLeft: "20px"}}>
                                            <h5>{setting.title}</h5>
                                         <Box sx={{display: "flex", flexDirection: "row", flexWrap: 'wrap'}}>
                                            {setting.options.map((option, optionIndex) => 
                                                option.featureConfig === undefined || checkFeatureConfig(setting.title, option.featureConfig) ?
                                                    <FormControlLabel 
                                                        key={optionIndex}
                                                        control={<Switch 
                                                                checked={option.value} 
                                                                onChange={(e) => handleSettingClicked(settingIndex, optionIndex)}
                                                            />
                                                        } 
                                                        label={option.label}
                                                    />
                                                :
                                                    <></>
                                                
                                            )}
                                        </Box>
                                    </Box>
                                )}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </>
    )
}

export default Settings